
    import './styles.scoped.css';
    export default {
  "root-refresh": "awsui_root-refresh_1hmm4_1dz62_9",
  "root-no-navigation-padding": "awsui_root-no-navigation-padding_1hmm4_1dz62_13",
  "root-no-tools-padding": "awsui_root-no-tools-padding_1hmm4_1dz62_16",
  "root-mobile": "awsui_root-mobile_1hmm4_1dz62_19",
  "notifications-sticky": "awsui_notifications-sticky_1hmm4_1dz62_23",
  "notifications-refresh": "awsui_notifications-refresh_1hmm4_1dz62_28",
  "notifications-refresh-mobile": "awsui_notifications-refresh-mobile_1hmm4_1dz62_32"
};
  